export enum PartDetailsTab {
  COSTS = 'costs',
  HISTORY = 'history',
  INVENTORY = 'inventory',
  MANUFACTURER = 'manufacturer',
  MEDIA = 'media',
  PRICES = 'prices',
  QUOTE_HISTORY = 'quoteHistory',
  SALES_HISTORY = 'salesHistory',
  SET_UP = 'setUp',
  SPECIFICATIONS = 'specifications',
  UOM = 'uom',
}
